import { Default, Detail,  List, Create } from "./views";
import { ApplyAction } from "./wizards";



const Module = {
    name: "ordermanagement",
    defaultRoutePath: "/zoho/manageableorder",
    menuItemScope: "sync",
    menuItemName: "ordermanagement",

    routes: [
        {
            path: "/zoho/manageableorder",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "applyAction",
            Component: ApplyAction,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        // {
        //     path: "create",
        //     Component: Create,
        // },
    ],
    
}

export default Module;
